import React from 'react';
import { formatLastActive } from '../../utils/utils';
import UserDetailLink from '../common/UserDetailLink';

/**
 * Wide activity-breakdown ranking for Most active users (23 columns).
 * Presentational: the container owns sort state, paging, and the modal trigger.
 *
 * Props: { users, page, sortField, sortOrder, onSort, onActiveDaysClick }
 */
const SortTh = ({ field, label, sortField, sortOrder, onSort }) => (
  <th className="au-th-sort" onClick={() => onSort(field)}>
    {label} {sortField === field ? (sortOrder === 'ASC' ? '🔼' : '🔽') : ''}
  </th>
);

const num = (v) => (v || v === 0 ? v : 0);
const dash = (v) => (v && v !== '-' ? formatLastActive(v) : '-');

const MostActiveTable = ({ users = [], page = 1, sortField, sortOrder, onSort, onActiveDaysClick }) => {
  const sortProps = { sortField, sortOrder, onSort };
  return (
    <div className="au-table-wrap">
      <table className="au-table au-mau-table" data-testid="au-mau-table">
        <thead>
          <tr>
            <th>No</th>
            <th>Name</th>
            <th>Email</th>
            <th>Watch Name</th>
            <th>Data Sources</th>
            <th>Country</th>
            <th>Platform</th>
            <th>Plan Info</th>
            <SortTh field="registered_date" label="Registered Date" {...sortProps} />
            <SortTh field="last_seen" label="Last Active (UTC)" {...sortProps} />
            <SortTh field="active_days_count" label="Active Days" {...sortProps} />
            <th>New Open</th>
            <th>Resume</th>
            <th>Total Activity count</th>
            <SortTh field="meditation_count" label="Meditation" {...sortProps} />
            <SortTh field="breath_count" label="Breath" {...sortProps} />
            <SortTh field="monitor_count" label="Monitor" {...sortProps} />
            <SortTh field="alerts_count" label="Alerts" {...sortProps} />
            <SortTh field="bp_count" label="BP" {...sortProps} />
            <SortTh field="sugar_count" label="Sugar" {...sortProps} />
            <SortTh field="oxygen_count" label="Oxygen" {...sortProps} />
            <SortTh field="reports_count" label="Reports" {...sortProps} />
            <SortTh field="event_logs_count" label="C&C" {...sortProps} />
          </tr>
        </thead>
        <tbody>
          {users.map((u, idx) => {
            const totalSum = (Number(u.total_newopen) || 0) + (Number(u.total_resume) || 0);
            return (
              <tr key={idx}>
                <td data-label="No">{(page - 1) * 20 + idx + 1}</td>
                <td data-label="Name" className="au-ellipsis"><UserDetailLink userId={u.user_id}>{u.name}</UserDetailLink></td>
                <td data-label="Email" className="au-ellipsis"><UserDetailLink userId={u.user_id} testId="user-detail-email-link">{u.email}</UserDetailLink></td>
                <td data-label="Watch Name" className="au-ellipsis">{u.watch_name || '-'}</td>
                <td data-label="Data Sources" className="au-ellipsis">{u.data_source || '-'}</td>
                <td data-label="Country">{u.country || '-'}</td>
                <td data-label="Platform">{u.platform || '-'}</td>
                <td data-label="Plan Info">{u.subscription_status || 'Default'}</td>
                <td data-label="Registered Date">{dash(u.registered_date)}</td>
                <td data-label="Last Active (UTC)">{dash(u.last_seen)}</td>
                <td data-label="Active Days">
                  <span className="au-link" onClick={() => onActiveDaysClick(u)} title="Click to view active dates">
                    {u.active_days_count}
                  </span>
                </td>
                <td data-label="New Open" className="tnum">{u.total_newopen || '-'}</td>
                <td data-label="Resume" className="tnum">{u.total_resume || '-'}</td>
                <td data-label="Total Activity count" className="tnum">{totalSum}</td>
                <td data-label="Meditation" className="tnum">{num(u.meditation_count)}</td>
                <td data-label="Breath" className="tnum">{num(u.breath_count)}</td>
                <td data-label="Monitor" className="tnum">{num(u.monitor_count)}</td>
                <td data-label="Alerts" className="tnum">{num(u.alerts_count)}</td>
                <td data-label="BP" className="tnum">{num(u.bp_count)}</td>
                <td data-label="Sugar" className="tnum">{num(u.sugar_count)}</td>
                <td data-label="Oxygen" className="tnum">{num(u.oxygen_count)}</td>
                <td data-label="Reports" className="tnum">{num(u.reports_count)}</td>
                <td data-label="C&C" className="tnum">{num(u.event_logs_count)}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default MostActiveTable;
